import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "SPRAVATO for Treatment-Resistant Depression | Neuro Wellness TMS Centers of America",
  description:
    "SPRAVATO (esketamine) is FDA-approved for treatment-resistant depression. Learn how it works and whether it may be an option for you.",
  canonical: "/spravato-for-treatment-resistant-depression",
  keywords:
    "SPRAVATO treatment-resistant depression, esketamine TRD, SPRAVATO Florida, SPRAVATO Coral Springs",
};

const relatedLinks = [
  { title: "SPRAVATO Overview", href: "/services/spravato" },
  {
    title: "What to Expect at Your First Session",
    href: "/spravato-what-to-expect",
  },
  {
    title: "TMS for Treatment-Resistant Depression",
    href: "/tms-for-treatment-resistant-depression",
  },
  { title: "Compare Treatments", href: "/compare-treatments" },
];

export default function SpravatoForTreatmentResistantDepression() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="SPRAVATO for TRD"
      title="SPRAVATO for Treatment-Resistant Depression"
      subtitle="SPRAVATO (esketamine) is FDA-approved for adults with treatment-resistant depression. It works through a different mechanism than standard antidepressants."
    >
      <DecisionSection heading="What SPRAVATO is">
        <p>
          SPRAVATO (esketamine) is a prescription nasal spray FDA-approved for
          adults with treatment-resistant depression — depression that hasn't
          responded to at least two antidepressants — and for adults with major
          depressive disorder who are experiencing suicidal thoughts or actions.
        </p>
        <p>
          It works on the glutamate system, which is different from the
          serotonin and norepinephrine systems that most oral antidepressants
          target. That's the whole reason it exists — for people the standard
          mechanism hasn't reached.
        </p>
      </DecisionSection>

      <DecisionSection heading="How it's given">
        <p>
          Because of its risks, SPRAVATO is only available through a restricted
          program called the SPRAVATO REMS. It must be self-administered in a
          certified healthcare setting under the supervision of a healthcare
          provider, with at least two hours of monitoring afterward.
        </p>
        <p>
          Neuro Wellness TMS Centers of America is a certified SPRAVATO REMS
          treatment center.
        </p>
      </DecisionSection>

      <DecisionSection heading="The schedule">
        <DecisionList
          items={[
            "Weeks 1–4: Twice weekly",
            "Weeks 5–8: Once weekly",
            "After that: You and your provider decide together",
            "Each visit runs about three hours",
            "You cannot drive after a session — you'll need a ride every time",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Safety">
        <p>
          SPRAVATO has Boxed Warnings for sedation, dissociation, respiratory
          depression, abuse and misuse, and increased risk of suicidal thoughts
          and behaviors. It is a Schedule III controlled substance. Please read
          the full Prescribing Information, including Boxed Warnings, and
          discuss any questions with your healthcare provider.
        </p>
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link to="/contactus" className="text-accent hover:underline">
            schedule a consultation
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
